import { SelectionType } from "src/js/stores/map/store";
import { createConstraintLikeClickResolver } from "../ConstraintsLayerType/constraintClickResolver/constraintClickResolver";

export const trafficClickResolver = createConstraintLikeClickResolver({
  selectionType: SelectionType.TRAFFIC,
});
